import { Component, HostBinding, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DashboardDataDialogComponent } from '../dashboard-data-dialog/dashboard-data-dialog.component';
import { MessengerService } from '@services/messenger/messenger.service';
import { Router } from '@angular/router';
import { PackageService } from '@services/packages/package.service';
import { MyExternalTokensService } from '@services/my-external-tokens/my-external-tokens.service';

@Component({
    selector: 'interactive-playouts',
    templateUrl: './interactive-playouts.component.html',
    styleUrls: ['./interactive-playouts.component.scss'],
    providers: [PackageService, MyExternalTokensService],
    standalone: false
})

export class InteractivePlayoutsComponent {
  @Input() dashboardData;
  @HostBinding('class.interactive-playouts') cl = true;

  hasSmart = false;
  hasIbextouch = false;
  hasIbexTV = false;
  hasIbexinfo = false;
  hasIbextablet = false;
  hasTokens = false;
  tweebiePackage;
  hasNoneTweebiePackage;
  contentOnly = true;
  configAllowed = false;

  constructor(public dialog: MatDialog, private packageService: PackageService, private ms: MessengerService, private router: Router, private tokenService: MyExternalTokensService) {
    this.ms.$activePrivileges.subscribe(privs => {
      this.configAllowed = !!privs?.length && !!privs.find(el => el.value === 'packages' && el.privilegeName === 'write');
    });
    this.init();
  }

  async init() {
    this.hasTokens = !!(await this.tokenService.find(0, 20))?.data?.length;
    const packages = await this.packageService.find(0, 100, { customerId: this.ms.$activeOrganisation.getValue().organisationCustomerId, underConstruction: { $ne: true } });
    if (packages?.data?.length) {
      packages.data.forEach(pak => {
        if (!pak.isScreenPackage) {
          this.tweebiePackage = pak;
        } else {
          this.hasNoneTweebiePackage = true;
        }
        if (pak.devices?.length) {
          this.hasSmart = pak.devices.includes('ibexsmart') || this.hasSmart;
          this.hasIbextouch = pak.devices.includes('ibextouch') || this.hasIbextouch;
          this.hasIbexinfo = pak.devices.includes('ibexinfo') || this.hasIbexinfo;
          this.hasIbextablet = pak.devices.includes('ibextablet') || this.hasIbextablet;
          this.hasIbexTV = pak.devices.includes('ibextv') || this.hasIbexTV;
        } else {
          this.hasSmart = pak.ibexApp?.enabled || this.hasSmart;
          this.hasIbextouch = pak.ibexTouch?.enabled || pak.screenUuids?.length > 0 || this.hasIbextouch;
          this.hasIbexinfo = pak.ibexInfo?.enabled || this.hasIbexinfo;
          this.hasIbextablet = pak.ibexTablet?.enabled || this.hasIbextablet;
          this.hasIbexTV = pak.ibexTV?.enabled || this.hasIbexTV;
        }
      });
    }

    this.dashboardData.forEach(route => {
      if (route?.path === 'navigation') {
        this.contentOnly = false;
      }
      route?.subRoutes?.forEach(subRoute => {
        if (subRoute.path === 'navigation') {
          this.contentOnly = false;
        }
      });
    });
  }

  openConfig(type) {
    const filterDashboard = this.dashboardData.filter(el => !!el && el.path !== 'dashboard' && !el.data.isTweebie && (this.hasTokens || !el.data.isIbexinfo));
    if (filterDashboard.length >= 2) {
      const dialogRef = this.dialog.open(DashboardDataDialogComponent, { data: { type: type, menuData: filterDashboard }, width: '400px', panelClass: 'dashboard-data-modal' });
      dialogRef.afterClosed().toPromise();
    } else if (filterDashboard.length === 1) {
      const route = filterDashboard[0].subRoutes.find(sr => type === 'content' ? sr.path === 'dynamic-content' : sr.path === 'my-packages');
      const title = filterDashboard[0].data.title;
      this.navigate(route, title);
    }
  }

  openNavigation(app) {
    const _filterDashboard = this.dashboardData.filter(el => !!el && el.path !== 'dashboard' && !el.data.isTweebie && !el.data.isIbexinfo);
    if (_filterDashboard.length >= 2) {
      const dialogRef = this.dialog.open(DashboardDataDialogComponent, { data: { type: 'navigation', menuData: _filterDashboard, app }, width: '400px', panelClass: 'dashboard-data-modal' });
      dialogRef.afterClosed().toPromise();
    } else if (_filterDashboard.length === 1) {
      const route = _filterDashboard[0].subRoutes.find(sr => sr.path === 'navigation');
      const title = _filterDashboard[0].data.title;
      this.navigate(route, title, { app });
    }
  }

  async navigate(route, title, queryParams = {}) {
    const commands = [{ outlets: { primary: [route?.path], org: this.ms.getOrganisation().name } }];
    if (route.data.packageId) {
      commands[0].outlets.primary.push(route.data.packageId);
    }
    await this.router.navigateByUrl('/', { skipLocationChange: true });
    await this.router.navigate(commands, { queryParams });
    route.mainDataTitle = title;
    this.ms.setPackageConfiguration(route.metaConfig);
    this.ms.setRouteFromDashboard(route);
  }
}
